import { styled as muiStyled, Theme } from '@mui/material/styles'
/**
 * só para ser compatível com extensão vscode-styled-components
 * @param strings
 * @returns
 */
const css = (strings: TemplateStringsArray, ...keys) => {
  return strings.map((x, idx) => x + (keys?.[idx] ?? '')).join('')
}

export const ModalContent = muiStyled('div')(({ theme }) => {
  return css`
    position: relative;
    .date-picker-calendar-weekdays {
      background-color: ${theme?.palette?.gray2.main} !important;
      height: 46px;
      position: fixed;
      z-index: 2;
      border-bottom: 1px solid rgb(197, 197, 197);
      width: 100%;
      top: 75px;
      left: 0px;
      right: 0px;
      display: flex;
      justify-content: center;

      .date-picker-calendar-weekdays-container {
        max-width: 350px;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        .date-picker-calendar-weekday {
          text-align: center;
          padding-top: 13px;
          color: ${theme?.palette?.textColor.main} !important;
          text-transform: uppercase;
          font-size: 11px;
          font-weight: 700;
        }
      }
    }
    .date-picker-calendar-container {
      margin-top: calc(46px + 20px);
      max-width: 350px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .date-picker-calendar-modal-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgb(255, 255, 255);
      box-shadow: rgba(0, 0, 0, 0.16) -2px -2px 20px;
      padding: 20px 10px;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 15px;
      .dates {
        color: ${theme.palette.priceColor.main};
        font-size: 14px;
        font-weight: 700;
        .nightCount {
          color: ${theme.palette.gray5.main};
          font-weight: 400;
          margin-left: 8px;
        }
      }
    }
  `
})

export const DatePickerContainer = muiStyled('div')(({ theme }) => {
  return css`
    position: relative;
    width: 100%;
    min-width: 240px;
    .date-picker-input {
      align-items: center !important;
      background: transparent !important;
      border: 1px solid ${theme?.palette.gray4.main};
      border-radius: 3px !important;
      color: ${theme?.palette?.textColor.main} !important;
      display: flex !important;
      font-family: 'Manrope', sans-serif;
      font-weight: 400 !important;
      max-width: 100% !important;
      padding: 0 !important;
      text-overflow: ellipsis !important;
      transition: ease-in-out 0.2s !important;
      white-space: nowrap !important;
      width: 100%;

      &.hasError {
        border-color: ${theme?.palette.error.main} !important;
      }

      &:active,
      &:focus-visible,
      &:hover,
      &:focus {
        border: 1px solid ${theme?.palette?.textColor.main} !important;
        outline: none;
      }

      .date-picker-input-content {
        align-items: center;
        background-color: #ffffff;
        border-radius: 3px !important;
        font-size: 16px;
        height: 48px;
        overflow: hidden !important;
        padding: 0 2px !important;
        text-align: center !important;
        width: 100% !important;

        position: relative;
        display: grid;
        grid-template-columns: 1fr 1fr;

        ${theme.breakpoints.up('sm')} {
          font-size: 14px;
          height: 40px;
        }

        .separator {
          position: absolute;
          left: 50%;
          width: 1px;
        }

        .date {
          position: relative;
          &.end-date {
            border-left: 1px solid ${theme?.palette.gray4.main};
          }

          .btn-decrease,
          .btn-increase {
            color: ${theme?.palette.textColor.main};
            background-color: transparent;
            border: none;
            position: absolute;
            height: 30px;
            width: 20px;
            padding: 0 !important;
            top: 50%;
            transform: translateY(-50%);
            &:disabled {
              color: ${theme?.palette.gray3.main};
            }
          }
          .btn-decrease {
            left: 0px;
          }
          .btn-increase {
            right: 0px;
          }
        }
      }
    }
    .date-picker-errors {
      font-size: 12px;
      color: ${theme.palette.error.main};
      font-weight: 400;
      line-height: 1.66;

      ${theme.breakpoints.down('sm')} {
        margin: 10px 14px;
      }
      ${theme.breakpoints.up('sm')} {
        position: absolute;
        margin: 0 14px;
        bottom: -14px;
        height: 14px;
      }
    }

    .date-picker-calendar-popper {
      display: none;
      ${theme.breakpoints.up('sm')} {
        &.open {
          display: block;
          position: absolute;
          padding: 40px 30px;
          background: rgb(255, 255, 255);
          box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 25px;
          border-radius: 4px;
          width: 1026px !important;
          z-index: 1410; //para ficar sobre a foto na tela de detalhes de hotel e indicador de fotos no image gallery
          .date-picker-calendar-popper-contents {
            position: relative;
            .months {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 56px;

              .prev-month,
              .next-month {
                position: absolute;
                top: -10px;
                padding: 0px;
                width: 32px;
                height: 32px;
              }
              .prev-month {
                left: 0;
              }
              .next-month {
                right: 0;
              }
            }
            .captions {
              font-size: 11px;
              font-weight: 400;
              display: flex;
              gap: 10px;
              align-items: center;
              .caption {
                display: flex;
                .text-bold {
                  font-weight: 900;
                }
                .unavailable-icon {
                  width: 15px;
                  height: 15px;
                  color: ${theme.palette.error.main} !important;
                  font-size: 12px;
                  line-height: 1em;
                }
                .min-nights {
                  width: 15px;
                  height: 15px;
                  font-size: 9px;
                  background-color: ${theme.palette.gray3.main};
                  border-radius: 0px 0px 4px 0px;
                }
              }
            }
          }
        }
      }
    }
  `
})
